import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import React, { useState, useMemo, useEffect } from "react"
import {
  FaChevronCircleLeft,
  FaChevronCircleRight,
  FaClock,
  FaFolderOpen,
  FaPen,
  FaPlus,
  FaSearch,
} from "react-icons/fa"
import { MdDelete } from "react-icons/md"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
  Input,
} from "reactstrap"
import StaffModal from "./StaffModal"
import Swal from "sweetalert2"
import AvaliblityTime from "./AvaliblityTime"
import ViewDocumentModal from "./DocumentModal"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import moment from "moment"
import PermittedComponent from "PermittedComponent"
import { usePermissionData } from "AppContext"

const StaffIndex = () => {
  const { checkAccess } = usePermissionData()

  const [loading, setLoading] = useState(false)

  const [perPageItem, setPerPageItem] = useState(10)
  const [searchString, setSearchString] = useState("")
  const [currentPage, setCurrentPage] = useState(1)

  const [staffList, setStaffList] = useState([])
  const [roles, setroles] = useState([])

  useEffect(() => {
    getStaffData()
    getRoles()
  }, [])

  async function getStaffData() {
    const APIdata = await fetchData(setLoading, "employee")
    if (APIdata?.success) {
      setStaffList(APIdata?.data)
    } else {
      Swal.fire({
        title: "Error Fetching Employees",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  async function getRoles() {
    const APIdata = await fetchData(setLoading, "roles-and-permissions")
    if (APIdata?.success) {
      setroles(APIdata?.data.reverse())
    } else {
      Swal.fire({
        title: "Error Fetching Roles",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  const [isDocModalOpen, setIsDocModalOpen] = useState(false)
  const [documents, setDocuments] = useState([])

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isAModalOpen, setISAModalOpen] = useState(false)

  const [staffData, setStaffData] = useState({})

  const toggleModal = () => setIsModalOpen(!isModalOpen)

  const aToogleModal = () => setISAModalOpen(!isAModalOpen)

  const handleChange = e => {
    const { name, value } = e.target
    setStaffData(prev => ({ ...prev, [name]: value }))
  }

  const handleSave = async () => {
    // Define only the fields that exist in the modal
    const modalFields = {
      name: staffData.name?.trim() || "",
      email: staffData.email?.trim() || "",
      phone: staffData.phone?.trim() || "",
      position: staffData.position || "",
      roleId: staffData.roleId || "",
      startDate: staffData.startDate || "",
      hourlyRate: staffData.hourlyRate || "",
      managerId: staffData.managerId || null,
      type: staffData.type || "",
      supervisorId: staffData.supervisorId || null,
      paymentFrequency: staffData.paymentFrequency || "",
      appLogin: staffData.appLogin ?? false,
      adminPanelAccess: staffData.adminPanelAccess ?? false,
      address1: staffData.address1?.trim() || "",
      address2: staffData.address2?.trim() || "",
      city: staffData.city?.trim() || "",
      country: staffData.country?.trim() || "",
      postcode: staffData.postcode?.trim() || "",
    }

    let payload = modalFields

    if (staffData.id) {
      const APIdata = await FetchPutData(
        setLoading,
        "employee",
        staffData.id,
        payload
      )

      if (APIdata?.data) {
        Swal.fire({
          title: "Employee Updated Successfully.",
          icon: "success",
        })
        getStaffData()
      } else {
        Swal.fire({
          title: "Something Went Wrong",
          text:
            APIdata?.response?.data?.message || "Failed to update employee.",
          icon: "error",
        })
      }
    } else {
      // Add new staff
      const APIdata = await FetchPostData(setLoading, "employee", payload)

      if (APIdata?.data) {
        Swal.fire({
          title: "Employee Added Successfully.",
          icon: "success",
        })
        getStaffData()
      } else {
        Swal.fire({
          title: "Something Went Wrong",
          text: APIdata?.response?.data?.message || "Failed to add employee.",
          icon: "error",
        })
      }
    }

    toggleModal()
    setStaffData({}) // Clear form
  }

  const handleASave = () => {
    console.log(e)
  }

  // 🔍 Filter + Paginate staff
  const filteredStaff = useMemo(() => {
    return staffList.filter(
      staff =>
        staff?.name?.toLowerCase()?.includes(searchString.toLowerCase()) ||
        staff?.email?.toLowerCase()?.includes(searchString.toLowerCase()) ||
        staff?.phone?.includes(searchString)
    )
  }, [staffList, searchString])

  const totalPages = Math.ceil(filteredStaff.length / perPageItem)

  const paginatedStaff = useMemo(() => {
    const start = (currentPage - 1) * perPageItem
    return filteredStaff.slice(start, start + perPageItem)
  }, [filteredStaff, currentPage, perPageItem])

  const toggleStatus = async (id, newStatus) => {
    // Ask for confirmation first
    const result = await Swal.fire({
      title: "Are You Sure?",
      text: `You want to change status of this Employee to ${
        newStatus ? "Active" : "Inactive"
      }?`,
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3d6eb6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    })

    if (!result.isConfirmed) {
      // Revert switch visually if user cancels
      setStaffList(prev =>
        prev.map(staff =>
          staff.id === id ? { ...staff, status: !newStatus } : staff
        )
      )
      return
    }

    // Proceed if confirmed
    setLoading(true)
    try {
      const APIdata = await FetchPutData(setLoading, "employee", id, {
        status: newStatus,
      })

      if (APIdata?.data) {
        setStaffList(prev =>
          prev.map(staff =>
            staff.id === id ? { ...staff, status: newStatus } : staff
          )
        )
        await Swal.fire({
          title: "Status Updated Successfully.",
          icon: "success",
        })
      } else {
        // Revert on failure
        setStaffList(prev =>
          prev.map(staff =>
            staff.id === id ? { ...staff, status: !newStatus } : staff
          )
        )
        Swal.fire({
          title: "Something Went Wrong",
          text: APIdata?.response?.data?.message || "Please try again later.",
          icon: "error",
        })
      }
    } catch (err) {
      // Revert on exception
      setStaffList(prev =>
        prev.map(staff =>
          staff.id === id ? { ...staff, status: !newStatus } : staff
        )
      )
      Swal.fire({
        title: "Error",
        text: err?.message || "Failed to update employee status.",
        icon: "error",
      })
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async (id, name) => {
    const result = await Swal.fire({
      title: "Are You Sure?",
      text: `You want to delete ${name}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3d6eb6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete it",
    })

    if (result.isConfirmed) {
      try {
        const APIdata = await FetchDeleteData(setLoading, "employee", id)

        if (APIdata?.data) {
          await Swal.fire({
            title: "Employee Deleted Successfully.",
            icon: "success",
          })
          getStaffData()
        } else {
          Swal.fire({
            title: "Something Went Wrong",
            text: APIdata?.response?.data?.message || "Please try again later.",
            icon: "error",
          })
        }
      } catch (err) {
        Swal.fire({
          title: "Error",
          text: err?.message || "Failed to delete employee.",
          icon: "error",
        })
      }
    }
  }

  const toggleDocModal = () => setIsDocModalOpen(!isDocModalOpen)

  const handleViewDocument = async id => {
    const APIdata = await fetchData(setLoading, `document/${id}`)
    if (APIdata?.data) {
      setDocuments(APIdata?.data)
    }
    toggleDocModal()
  }

  const handleDocumentStatusChange = async (docId, status) => {
    const APIdata = await FetchPutData(setLoading, "document", docId, {
      status,
    })
    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Success",
        text: `Document ${
          status === true ? "Approved" : "Rejected"
        } Successfully`,
        icon: "success",
      })
      setDocuments(prev =>
        prev.map(doc => (doc.id === docId ? { ...doc, status } : doc))
      )
    }
  }

  return (
    <div className="page-content">
      <PermittedComponent isAccess={checkAccess(3, 1) || checkAccess(3, 2)}>
        <Container fluid>
          <Breadcrumb
            title="Dashboard"
            breadcrumbItem="Employee"
            description="Manage the all Employees Details  from Here."
          />
          {loading && <Loader />}
          <Row>
            <Col lg="12" className="px-0">
              <Card className="shadow-lg">
                <CardBody>
                  {/* Header Controls */}
                  <div className="d-flex justify-content-between">
                    <div className="d-flex gap-3">
                      <select
                        className="form-select rounded-4 ps-3 pe-5 w-auto"
                        value={perPageItem}
                        onChange={e => {
                          setPerPageItem(Number(e.target.value))
                          setCurrentPage(1)
                        }}
                      >
                        <option value={10}>Show 10</option>
                        <option value={20}>Show 20</option>
                        <option value={50}>Show 50</option>
                      </select>

                      <div className="position-relative">
                        <input
                          className="form-control rounded-4 px-3 pe-5"
                          placeholder="Search Employee"
                          value={searchString}
                          onChange={e => setSearchString(e.target.value)}
                        />
                        <span className="position-absolute end-0 top-50 translate-middle-y pe-3 text-muted">
                          <FaSearch />
                        </span>
                      </div>
                    </div>

                    {checkAccess(3, 3) && (
                      <div className="d-flex gap-3">
                        <Button
                          className="btn-blue"
                          onClick={() => {
                            setStaffData({})
                            toggleModal()
                          }}
                        >
                          <FaPlus className="me-2" /> Employee
                        </Button>
                      </div>
                    )}
                  </div>

                  {/* Staff Table */}
                  <div className="mt-3">
                    <Table responsive hover>
                      <thead className="bg-blue text-white">
                        <tr>
                          <th>#</th>
                          <th>Employee Name</th>
                          <th className="text-center">Email Address</th>
                          <th className="text-center">Phone Number</th>
                          <th className="text-center">Designation</th>
                          <th className="text-center">Joining Date</th>
                          <th className="text-center">Status</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedStaff.length > 0 ? (
                          paginatedStaff.map((staff, index) => (
                            <tr key={staff.id}>
                              <td>
                                {(currentPage - 1) * perPageItem + index + 1}
                              </td>
                              <td className="d-flex align-items-center">
                                <img
                                  src={
                                    staff?.profilePicture
                                      ? `${process.env.REACT_APP_IMAGE_PATH}${staff?.profilePicture}`
                                      : "https://ui-avatars.com/api/?name=" +
                                        encodeURIComponent(
                                          staff?.name || "User"
                                        ) +
                                        "&background=random"
                                  }
                                  alt={staff?.name}
                                  className="rounded-circle me-2"
                                  width="35"
                                  height="35"
                                  style={{ objectFit: "cover" }}
                                />
                                {staff?.name}
                              </td>
                              <td className="text-center">
                                {staff.email || "--"}
                              </td>
                              <td className="text-center">
                                {staff.phone || "--"}
                              </td>
                              <td className="text-center text-capitalize">
                                {staff.position || "--"}
                              </td>
                              <td className="text-center text-capitalize">
                                {staff.startDate
                                  ? moment(staff.startDate).format("DD-MM-YYYY")
                                  : "--"}
                              </td>
                              <td>
                                <div className="form-check form-switch d-flex justify-content-center">
                                  <Input
                                    type="switch"
                                    checked={staff.status}
                                    onChange={e =>
                                      toggleStatus(staff.id, e.target.checked)
                                    }
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center justify-content-center">
                                  {checkAccess(3, 4) && (
                                    <Button
                                      size="sm"
                                      className="btn-blue me-2"
                                      onClick={() => {
                                        setStaffData(staff)
                                        aToogleModal()
                                      }}
                                    >
                                      <FaClock size={14} />
                                    </Button>
                                  )}
                                  {checkAccess(3, 4) && (
                                    <Button
                                      color="warning"
                                      className="me-2"
                                      size="sm"
                                      onClick={() =>
                                        handleViewDocument(staff.id)
                                      }
                                    >
                                      <FaFolderOpen size={14} />
                                    </Button>
                                  )}
                                  {checkAccess(3, 5) && (
                                    <Button
                                      color="success"
                                      size="sm"
                                      className="me-2"
                                      onClick={() => {
                                        setStaffData(staff)
                                        toggleModal()
                                      }}
                                    >
                                      <FaPen size={14} />
                                    </Button>
                                  )}
                                  {checkAccess(3, 6) && (
                                    <Button
                                      color="danger"
                                      size="sm"
                                      onClick={() =>
                                        handleDelete(staff.id, staff.name)
                                      }
                                    >
                                      <MdDelete size={14} />
                                    </Button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="text-center text-muted">
                              No staff found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  {/* Pagination */}
                  <div className="d-flex justify-content-between  gap-2">
                    <p className="mb-0">
                      Showing {paginatedStaff.length} out of {staffList.length}{" "}
                      Employees.
                    </p>
                    <div>
                      <Button
                        size="sm"
                        disabled={currentPage === 1}
                        className="fs-6"
                        onClick={() => setCurrentPage(prev => prev - 1)}
                      >
                        <FaChevronCircleLeft />
                      </Button>
                      {Array.from({ length: totalPages }, (_, i) => (
                        <Button
                          key={i}
                          size="sm"
                          className="mx-2 fs-6"
                          color={currentPage === i + 1 ? "primary" : "light"}
                          onClick={() => setCurrentPage(i + 1)}
                        >
                          {i + 1}
                        </Button>
                      ))}
                      <Button
                        size="sm"
                        className="fs-6"
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage(prev => prev + 1)}
                      >
                        <FaChevronCircleRight />
                      </Button>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <StaffModal
          isOpen={isModalOpen}
          toggle={toggleModal}
          staffData={staffData}
          roles={roles}
          staffList={staffList}
          onChange={handleChange}
          onSave={handleSave}
          setStaffData={setStaffData}
        />

        <AvaliblityTime
          isOpen={isAModalOpen}
          toggle={aToogleModal}
          onSave={handleASave}
          user={staffData}
        />

        <ViewDocumentModal
          isOpen={isDocModalOpen}
          toggle={toggleDocModal}
          documents={documents}
          onStatusChange={handleDocumentStatusChange}
        />
      </PermittedComponent>
    </div>
  )
}

export default StaffIndex
